// StayZen official logo (uploaded artwork).
// variant:
//   "square"           — stacked tile (gold on dark-blue bg) for dark surfaces
//   "horizontal"       — horizontal tile (gold on dark-blue bg) for dark surfaces
//   "horizontal-blue"  — horizontal, dark-blue mark on transparent bg (for beige/light surfaces)
//   "square-blue"      — square stacked, dark-blue on transparent (for beige/light surfaces)

const SOURCES = {
  square: "/stayzen-square.jpeg",
  horizontal: "/stayzen-horizontal.jpeg",
  "square-blue": "/stayzen-square-blue.png",
  "horizontal-blue": "/stayzen-horizontal-blue.png",
};

const Logo = ({ size = 56, variant = "square", className = "", alt = "StayZen Premium" }) => {
  const src = SOURCES[variant] || SOURCES.square;
  const style =
    variant.startsWith("horizontal")
      ? { height: size, width: "auto" }
      : { height: size, width: "auto" };

  return (
    <img
      src={src}
      alt={alt}
      style={style}
      className={`block object-contain select-none ${className}`}
      draggable={false}
    />
  );
};

export default Logo;
